import _ from 'lodash';
import React, { Component } from 'react';
import Modal from 'react-modal';

import misc from '../../misc';
import LocationEditContainer from './LocationEditContainer';

export class LocationList extends Component {
  constructor() {
    super();

    this.state = {
      modalIsOpen: false,
      locationId: null
    };
  }

  openModal = locationId => {
    this.setState({
      modalIsOpen: true,
      locationId: locationId
    });
  };

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
      locationId: null
    });
  };

  renderLocation(location) {
    return (
      <div key={location.id} className="list-group-item">
        {location.name}
      </div>
    );
  }

  renderLocationEditable(location) {
    return (
      <a
        key={location.id}
        onClick={() => {
          this.openModal(location.id);
        }}
        className="list-group-item list-group-item-action"
      >
        {location.name}
      </a>
    );
  }

  renderAddNew() {
    return (
      <a
        onClick={() => {
          this.openModal(null);
        }}
        className="list-group-item list-group-item-action bg-light"
      >
        + Add New
      </a>
    );
  }

  renderModal() {
    Modal.setAppElement('#root');
    const modalStyles = {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
      },
      overlay: {
        zIndex: 3
      }
    };
    return (
      <Modal
        isOpen={this.state.modalIsOpen}
        onRequestClose={this.closeModal}
        style={modalStyles}
      >
        <LocationEditContainer
          id={this.state.locationId}
          onCancel={this.closeModal}
          onComplete={this.closeModal}
        />
      </Modal>
    );
  }

  render() {
    const renderedLocations = _.map(
      this.props.locations,
      location =>
        this.props.isEditable
          ? this.renderLocationEditable(location)
          : this.renderLocation(location)
    );

    return (
      <React.Fragment>
        <div className="card">
          <div className="list-group list-group-flush">
            {renderedLocations}
            {this.props.isEditable && this.renderAddNew()}
          </div>
        </div>
        {this.props.isEditable && this.renderModal()}
      </React.Fragment>
    );
  }
}

export default misc.lib.toJS(LocationList);



// WEBPACK FOOTER //
// ./src/modules/locations/components/LocationList.js